<template>
  <div class="switch-wrapper">
    <h2 class="title">切换账号</h2>

    <!-- 用户名 -->
    <div class="info-row">
      <span class="label">用户名：</span>
      <span>{{ switchAccount.userName }}</span>
    </div>

    <!-- 密码（label + form + 忘记密码） -->
    <div v-if="isEnterpriseTarget" class="password-row">
      <!-- 左侧 label -->
      <span class="label required">密码：</span>

      <!-- 右侧输入 + 校验 + 忘记密码 -->
      <div class="password-content">
        <a-form-model ref="formRef" :model="form" :rules="rules">
          <a-form-model-item prop="password" class="password-item">
            <a-input-password v-model="form.password" placeholder="请输入密码"
              ><a-icon
                slot="prefix"
                type="lock"
                :style="{ color: 'rgba(0,0,0,.25)' }"
              />
            </a-input-password>
          </a-form-model-item>
        </a-form-model>

        <a class="forget-link" @click="$emit('forgetPassword')">忘记密码</a>
      </div>
    </div>

    <!-- 按钮 -->
    <div class="btn-row">
      <a-button class="btn-cancel" @click="closeSwitchMoudle">取消</a-button>
      <a-button type="primary" @click="handleConfirm" :loading="state.button" :disabled="state.button">确定</a-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import store from "@/store";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import storage from "store";
import { timeFix } from "@/utils/util";
export default {
  props: {
    switchAccount: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      form: { password: "" },
      rules: {
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      state:{
        button:false
      }
    };
  },
  methods: {
    //调用vuex中login方法
    ...mapActions(["SwitchAccount"]),

    handleConfirm() {
      if (!this.isEnterpriseTarget) {
        this.submitSwitch(null);
        return;
      }
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let switchPassword;
          try {
            switchPassword = this.toBase64Utf8(this.form.password);
          } catch (error) {
            this.$notification.error({
              message: "错误",
              description: "密码编码失败，请重新输入",
            });
            return;
          }
          this.submitSwitch(switchPassword);
        }
      });
    },
    submitSwitch(switchPassword) {
      this.state.button = true;
      this.SwitchAccount({
        switchAccountId: this.switchAccount.accountId,
        switchPassword,
      })
        .then((res) => this.loginSuccess(res))
        .catch((err) => this.requestFailed(err));
    },
    closeSwitchMoudle() {
      this.$emit("closeSwitchMoudle");
    },

    toBase64Utf8(value) {
      const bytes = new TextEncoder().encode(value);
      let binary = "";
      bytes.forEach((byte) => {
        binary += String.fromCharCode(byte);
      });
      return window.btoa(binary);
    },

    loginSuccess(res) {
      // 延迟 1 秒显示欢迎信息
      if (res.code == "200") {
        //重置token及基础信息
        store.commit("SET_TOKEN", "");
        store.commit("SET_ACCOUNT_TYPE", "");
        store.commit("SET_ACCOUNT_ID", "");
        store.commit("SET_USER_NAME", "");
        storage.remove(ACCESS_TOKEN);
        //向vuex与storage加入新token
        const result = res;
        storage.set(ACCESS_TOKEN, result.token, 12 * 60 * 60 * 1000);
        store.commit("SET_TOKEN", result.token);
        setTimeout(() => {
          this.$notification.success({
            message: "账号切换成功",
            description: `${timeFix()}，欢迎回来`,
          });
        }, 300);
        setTimeout(() => {
          this.state.button = false
          this.$router.go(0);
        }, 1000);
        
      } else {
        this.state.button = false
        this.$notification["error"]({
          message: "错误",
          description: res.msg,
        });
      }
    },
    //服务器报错时发生
    requestFailed(err) {
      this.state.button = false
      console.log(err);
      this.$notification["error"]({
        message: "错误",
        description:
          ((err.response || {}).data || {}).message || "网络异常，请稍后再试",
        duration: 4,
      });
    },
  },
  computed: {
    isEnterpriseTarget() {
      return Number((this.switchAccount || {}).accountType) === 13;
    },
  },
};
</script>

<style scoped>
.switch-wrapper {
  padding: 10px 20px 0 20px;
}

.title {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
}

/* 用户名行 */
.info-row {
  margin: 12px 0;
  display: flex;
  align-items: center;
}

/* 密码行整体 */
.password-row {
  display: flex;
  align-items: flex-start; /* ⭐ 确保忘记密码不下沉 */
  margin: 12px 0;
}

.label {
  width: 70px;
  font-size: 14px;
  color: #333;
  line-height: 32px;
}

.label.required::before {
  content: "*";
  color: #ff4d4f;
  margin-right: 4px;
}

/* 右侧整体区域（输入框 + 错误提示 + 忘记密码） */
.password-content {
  flex: 1;
  display: flex;
  align-items: flex-start;
}

/* 让 form-item 占据左侧 */
.password-item {
  flex: 1;
  margin-bottom: 0; /* 避免多余空白 */
}

/* 忘记密码 */
.forget-link {
  margin-left: 10px;
  /* white-space: nowrap; */
  font-size: 13px;
  /* cursor: pointer; */
  line-height: 40px; /* ⭐ 永远与输入框在一条线上 */
}

/* 按钮行 */
.btn-row {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  gap: 20px;
}

.btn-cancel {
  border: 1px solid #d9d9d9;
}

/* 输入框高度统一 */
.password-item /deep/ .ant-input {
  height: 32px !important;
  border-radius: 4px;
}
</style>
